export interface ImageTabsConfig {
    image: HTMLImageElement;
    tabs: NodeListOf<HTMLElement>;
}

export class ImageTabs {
    private readonly elements: {
        image: HTMLImageElement;
        tabs: NodeListOf<HTMLElement>;
    };

    constructor(options: ImageTabsConfig) {
        this.elements = options;
        this.init();
    }

    protected tabHoverHandler(tab: HTMLElement) {
        const
            {image, tabs} = this.elements,
            url = tab.getAttribute(`data-image`);

        if (!url) return;
        image.src = url;
        tabs.forEach((tab) => {
            tab.classList.remove(`is-active`);
        });
        tab.classList.add(`is-active`);
    }

    protected init(): void {
        const {tabs} = this.elements;
        if (!tabs.length) return;

        tabs.forEach((tab) => {
            tab.addEventListener('mouseover', () => this.tabHoverHandler(tab));
        });
    }
}